import React from 'react';
import { Spinner, Wrapper } from './simple-loader.styled';

interface Props {
  show: boolean;
}

/** Небольшой блок с лоадером внутри **/
export const SimpleLoader = React.memo(({ show }: Props) => {
  if (!show) {
    return <></>;
  }
  return (
    <Wrapper data-testid={'simple-loader'} className={'simple-loader'}>
      <Spinner className={'simple-spinner'} />
    </Wrapper>
  );
});
